export default __webpack_public_path__ + "static/media/menu_close.69bf2178.svg";